import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3915255205/src/src/app/layout/ClientWrapper.tsx");
